import React from "react";
import { CFooter } from "@coreui/react";

const Footer = () => {
  return <CFooter fixed={false}></CFooter>;
};

export default React.memo(Footer);
